import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

interface IcodominoIconData {
  attrs: any[];
  icon: any;
  properties: {
    name: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class IcodominoService {

  cachedIconNames: string[];

  constructor(
    private http: HttpClient,
  ) { }

  getAllIconNames() {

    if (this.cachedIconNames) {
      return of(this.cachedIconNames);
    }

    return this.http.get<{ icons: IcodominoIconData[] }>('/assets/icodomino/selection.json').pipe(
      map(res => res && res.icons ? res.icons.map(i => i.properties.name) : []),
      tap(res => this.cachedIconNames = res)
    );
  }

  search(term): Observable<object> {
    return this.http.get('/assets/icodomino/selection.json')
      .pipe(
        map(res => res['icons'].map(i => i['properties']['name']).filter(evt => evt.toLowerCase().includes(term)))
      )
  }
}
